var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullyFeaturedLoans(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 59V38.333l2-.933 8 5.6 1.5-5.6h2L36 27h5l-6.5 10.4L31 43 21 59z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56l8.5 3 3-9.5-3-6.5-5.5 3-3 10z",
    fill: "#FFF7EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v1m-19-1v11h19v-4M38 40l12.5-9L63 40",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.693 43.799a.996.996 0 00-1.175.784 1.004 1.004 0 00.79 1.176l.385-1.96zm9.177 1.474c.275.48.886.648 1.366.375a.997.997 0 00.37-1.363l-1.736.988zM62.5 44l.576.82L62.5 44zm-5.193 1.76c.884.176 1.777.402 2.692.334.983-.074 1.921-.465 3.077-1.274l-1.152-1.64c-.987.691-1.584.883-2.082.92-.566.042-1.101-.092-2.15-.301l-.385 1.96zm5.769-.94c.755-.53 1.431-.899 2.024-.925.26-.012.513.043.78.216.282.182.625.525.99 1.162l1.735-.988c-.475-.83-1.019-1.448-1.642-1.851a3.28 3.28 0 00-1.96-.537c-1.231.055-2.334.762-3.079 1.283l1.152 1.64z",
    fill: "#376E66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.267 43.827l3.116 5.188-2.989 8.87c-.307.87-1.318 1.326-2.254 1.023l-5.504-1.784C61.7 56.82 61.192 55.869 61.5 55l2.989-8.87.613-.337",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.674 53.258s.45.38.978.584c.52.205 1.242.146 1.56-.404.204-.355.206-.803.005-1.16-.196-.347-.576-.522-.9-.721-.276-.173-.54-.386-.65-.709a1.208 1.208 0 01.088-.968c.318-.55.876-.672 1.56-.405.568.221.978.584.978.584M66.653 53.902l-.309.837M68.6 48.65l-.303.814",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48 40h5v5h-5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.286 41v22.571a2 2 0 002 2H74a2 2 0 002-2V29a2 2 0 00-2-2H38.5M20.286 62.286H29.5m45.428 0H32.5M39.571 72h17.143M43.857 66.643v4.286M52.429 68.5v2.429",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12a1 1 0 100-2v2zm4-2a1 1 0 100 2v-2zm19.642 33.39l.605-.796-.605.796zm-7.106-5.4l-.605.797.605-.796zM34 13v22.806h2V13h-2zM4 35.583V13H2v22.583h2zm18.326 1H5v2h17.326v-2zm8.118 2.778v3.631h2v-3.63h-2zm.803 3.233l-7.106-5.4-1.21 1.593 7.106 5.4 1.21-1.593zM5 12h2v-2H5v2zm6 0h22v-2H11v2zm19.444 30.992a.5.5 0 01.803-.398l-1.21 1.592c.988.75 2.407.047 2.407-1.194h-2zm2.778-6.409a2.778 2.778 0 00-2.778 2.778h2c0-.43.349-.778.778-.778v-2zm-10.896 2a1 1 0 01.605.204l1.21-1.592a3 3 0 00-1.815-.612v2zM2 35.583a3 3 0 003 3v-2a1 1 0 01-1-1H2zm32 .223c0 .43-.348.777-.778.777v2A2.778 2.778 0 0036 35.806h-2zM36 13a3 3 0 00-3-3v2a1 1 0 011 1h2zM4 13a1 1 0 011-1v-2a3 3 0 00-3 3h2z",
    fill: "#376E66"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 17.75l-13.5 13.5M13.625 22.25a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM23.375 32a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFullyFeaturedLoans;